// English dictionary — keys mirror sq.js.
const en = {
  // Header
  'header.ann.shipping': 'fast shipping',
  'header.ann.guarantee': '30-day guarantee',
  'header.about': 'About',
  'header.contact': 'Contact Us',
  'header.search': 'Search',
  'header.searchEmpty': 'No products found',
  'header.wishlist': 'Wishlist',
  'header.cart': 'Cart',
  'header.menu': 'Menu',

  // Footer
  'footer.contact': 'Contact',
  'footer.policiesTitle': 'Policies and terms of use',
  'footer.terms': 'Terms and Conditions',
  'footer.privacy': 'Privacy Policy',
  'footer.legal': 'Legal Notices',
  'footer.returns': 'Return Policy',
  'footer.shippingPolicy': 'Shipping Policy',
  'footer.newsletterTitle': 'Subscribe to our email',
  'footer.newsletterDesc': 'Get news and offers from Fletaime.',
  'footer.emailPlaceholder': 'Email address',
  'footer.subscribe': 'Subscribe',
  'footer.copyright': '© 2026 Fletaime, All rights reserved.',

  // Categories
  'cat.travel': 'Travel Book',
  'cat.wedding': 'Love Book',
  'cat.baby': 'Baby Book',
  'cat.kitchen': 'Kitchen Diary',
  'cat.agenda': '2026 Planner',
  'cat.kids': 'Kids Book',
  'cat.frame': 'Wall Frame',
  'cat.all': 'All Products',

  // Product card
  'card.new': 'new',
  'card.orderNow': 'Order Now',
  'card.addWish': 'Add to wishlist',
  'card.removeWish': 'Remove from wishlist',

  // Home
  'home.heroSubtitle': 'personalised books that turn your moments into something real',
  'home.orderNow': 'Order Now',
  'home.rowPrev': 'Back',
  'home.rowNext': 'Forward',
  'home.seeAllModels': 'See all designs →',
  'home.brandTitle': 'meet the brand',
  'home.brandSub': 'the story behind your stories',
  'home.story1Title': 'moments that last',
  'home.story1Text': 'Fletaime brings your most cherished memories to life through carefully crafted photobooks you can hold in your hands forever.',
  'home.story2Title': 'made to be loved',
  'home.story2Text': 'Made to be flipped through often and kept somewhere visible — not forgotten in a drawer.',
  'home.story3Title': 'your story, your way',
  'home.story3Text': 'With simple tools and full personalisation, Fletaime puts creativity in your hands — every memory becomes something personal.',
  'home.story4Title': 'connections that bring us together',
  'home.story4Text': 'Beyond preserving memories, we celebrate the connections they create between people, places and moments.',
  'home.testimonialsTitle': 'What our customers say',
  'home.galleryTitle': 'fletaime + you',
  'home.gallerySub': 'created by you, loved by us',
  'home.gallerySocial': 'find us on social media',
  'home.helpTitle': 'Need help?',
  'home.helpDesc': 'Write to us on WhatsApp or email — our team replies quickly.',

  // Catalog (/photobooks)
  'catalog.bestsellers': 'Bestsellers',
  'catalog.albums': 'Albums',
  'catalog.loading': 'Loading products...',
  'catalog.noBestsellers': 'No products marked as "Bestsellers" yet.',
  'catalog.options': 'Options',
  'catalog.searchPlaceholder': 'Search',
  'catalog.selectedCount': 'Selected products:',
  'catalog.sortDefault': 'Default order',
  'catalog.sortPriceAsc': 'Price: low to high',
  'catalog.sortPriceDesc': 'Price: high to low',
  'catalog.sortName': 'Name (A-Z)',
  'catalog.noResults': 'No products found for this filter.',

  // Cart / Wishlist
  'shoplist.cartTitle': 'My Cart',
  'shoplist.cartEmpty': 'Your cart is empty.',
  'shoplist.viewProducts': 'Browse Products',
  'shoplist.continueOrder': 'Continue Order',
  'shoplist.remove': 'Remove',
  'shoplist.total': 'Total:',
  'shoplist.wishTitle': 'Wishlist',
  'shoplist.wishEmpty': 'You have no favourite products yet.',
  'card.view': 'View Product',

  // Product page
  'product.loading': 'Looking for the product...',
  'product.features': 'Features:',
  'product.totalPrice': 'Total Price:',
  'product.inCart': '✓ In Cart',
  'product.addToCart': 'Add to Cart',
  'product.choosePhotos': 'Choose the number of photos',
  'pageOption.50to75': '50 to 75 Photos',
  'pageOption.75to150': '75 to 150 Photos',
  'product.kitchenNote': 'For your personalisation idea, write to us in the comment field on the form',
  'product.order': 'Order',
  'product.designOnline': 'Design Your Book Online',
  'product.security': '100% secure – your data is protected.',
  'product.tryFramePhoto': 'Try Your Photo in the Frame',
  'product.uploadFramePhoto': 'Upload a Photo to the Frame',
  'product.frameHint': 'Upload a photo to see how it looks in the frame',
  'product.uploadPhoto': 'Upload Photo',
  'product.kidsHint': 'Upload 1 photo for your Kids Book',
  'product.uploadedPhotos': 'Uploaded Photos ({n})',
  'product.customizeTitle': 'Personalise Your Book',
  'product.seeOurProducts': 'See Our Products',
  'product.seeDetails': 'SEE DETAILS',
  'product.promoPrice': 'Promotional price',
  'product.alert.rawFormat': 'The photo "{name}" is in an unsupported RAW/TIFF format.\n\nPlease export it as JPG and try again.',
  'product.alert.notPhotos': 'Some files are not photos.\n\nInvalid files: {names}\n\nPlease upload photos only.',
  'product.alert.maxReached': 'You have reached the maximum limit of {max} photos for the selected package ({label}).\n\nIf you want to upload more photos, choose a bigger package.',
  'product.alert.remainingOnly': 'You can only upload {remaining} more photos.\n\nSelected package: {label} (max {max} photos)',
  'product.alert.onlyPhotos': 'Please upload photos only.',

  // PhotoBook designer
  'designer.defaultTitle': 'Photo Book',
  'designer.openDrawer': 'Open panel',
  'designer.closeDrawer': 'Close panel',
  'designer.pageLimits': 'Page Limits',
  'designer.uploadMore': 'Upload more photos ({n}/5 min) to get started.',
  'designer.uploadedCount': 'You have {count} / {max} photos uploaded.',
  'designer.maxLine': 'Max: {maxPhotos} photos | {maxPages} pages',
  'designer.statPages': 'Pages',
  'designer.statPhotosInPages': 'Photos in pages',
  'designer.statUploaded': 'Uploaded',
  'designer.processing': 'Processing...',
  'designer.continueOrder': 'Continue to Order',
  'designer.previewBtn': 'View as Book',
  'preview.title': 'Book Preview',
  'preview.editBtn': 'Continue Editing',
  'preview.prev': 'Previous page',
  'preview.next': 'Next page',
  'preview.pageCounter': 'Page {current} / {total}',
  'designer.minPhotosWarning': 'Upload at least 5 photos to continue',
  'designer.helpTitle': 'Tips',
  'designer.customizeCover': 'Customize cover',
  'designer.help1': 'Upload photos by clicking "+ Add Photos"',
  'designer.help2': 'Click an empty slot to upload a photo directly',
  'designer.help3': 'Choose different layouts for your pages',
  'designer.help4': 'When you\'re done, click "Continue to Order"',
  'designer.preparing': 'Preparing...',
  'designer.pageWord': 'pages',
  'designer.alert.noPhotosInPages': 'Please add at least one photo to a page before continuing with your order.',
  'designer.alert.unplaced': '{count} photos were uploaded but NOT placed on any page - they will NOT be included in the printed book:\n\n{names}\n\nPlease place these photos on a page (or remove them from the library if you don\'t want them) before continuing.',
  'designer.alert.genericError': 'An error occurred: {message}',

  // Cover editor
  'cover.zoomIn': 'Zoom in',
  'cover.zoomOut': 'Zoom out',
  'cover.rotate': 'Rotate',
  'cover.reset': 'Reset',
  'cover.delete': 'Delete',
  'cover.uploadPhoto': 'Upload photo',
  'cover.textAndColors': 'Text & Colours',
  'cover.background': 'Background',
  'cover.titleColor': 'Title colour',
  'cover.yearColor': 'Year colour',
  'cover.urlColor': 'URL colour (back)',
  'cover.font': 'Font',
  'cover.titleSize': 'Title size:',
  'cover.yearSize': 'Year size:',
  'cover.titleLabel': 'Title',
  'cover.titlePlaceholder': 'e.g. BARCELONA',
  'cover.yearLabel': 'Year',
  'cover.spineTitleLabel': 'Spine title (top)',
  'cover.spineTitlePlaceholder': 'e.g. Country',
  'cover.spineDateLabel': 'Spine date (bottom)',
  'cover.spineDatePlaceholder': 'e.g. 2026',
  'cover.introTitle': 'Design your cover your way',
  'cover.introText': 'You can change the cover title, photo, and colors. There is also a side strip (spine) with editable text — change "Country" and "Date" as you like.',
  'cover.introClose': 'Got it',
  'cover.spineColor': 'Spine text color',
  'cover.spineNote': 'This text is also saved on the final product, as a separate spine page.',
  'cover.layoutTitle': 'Cover Layout',
  'cover.back': 'Back',
  'cover.front': 'Front',
  'cover.layout1Photo': '1 Photo',
  'cover.layout4Photo': '4 Photos',
  'cover.layoutFullPage': 'Full Page',
  'cover.tabText': 'Text',
  'cover.tabLayout': 'Layout',
  'cover.tabStickers': 'Stickers',
  'cover.stickersTitle': 'Stickers',
  'cover.stickersLoading': 'Loading...',
  'cover.stickersEmpty': 'No stickers in this category yet.',
  'cover.layoutNoPhoto': 'No Photo',
  'cover.previewNote': '33 × 48 cm · Drag the text to move it',

  // Page layout names
  'pagesLayout.single': 'One photo (Full Page)',
  'pagesLayout.two-horizontal': 'Two photos, horizontal',
  'pagesLayout.three-top': 'Three photos (1 top, 2 bottom)',
  'pagesLayout.four-grid': 'Four photos (grid)',
  'pagesLayout.collage': 'Collage (5 photos)',

  // Pages manager (designer)
  'pages.pageNumber': 'Page {n}',
  'pages.pageRangeNumber': 'Page {a}-{b}',
  'pages.uploadSlot': 'Upload photo',
  'pages.myPhotos': 'My Photos',
  'pages.loading': 'Loading...',
  'pages.addPhotos': '+ Add Photos',
  'pages.addFromPhone': 'Add from Phone',
  'pages.pairingTitle': 'Add photos from your phone',
  'pages.pairingSubtitle': 'Scan the QR code or open the link on your phone, pick your photos, and they\'ll appear here automatically.',
  'pages.copy': 'Copy',
  'pages.copied': 'Copied ✓',
  'pages.pairingAdded': '✓ {count} photo(s) added from phone',
  'pages.pairingWaiting': 'Waiting for photos from your phone...',
  'pages.close': 'Close',
  'pages.maxPhotosShort': 'Max {max} photos',
  'pages.aiGeneratingTitle': 'Generating with AI',
  'pages.aiWarningStrong': 'AI can make mistakes',
  'pages.aiWarningRest': ', we\'re analysing your photos and building the pages',
  'pages.bgLabel': 'Background:',
  'pages.uploadMorePhotos': 'Upload more photos ({n}/5 min)',
  'pages.photoStats': '{count} / {max} photos - max {maxPages} pages',
  'pages.font': 'Font',
  'pages.fontSize': 'Size',
  'pages.style': 'Style',
  'pages.alignment': 'Alignment',
  'pages.color': 'Colour',
  'pages.applyAllPages': 'Apply to all pages',
  'pages.deleteText': '🗑 Delete text',
  'pages.addPageTitle': 'Add new page',
  'pages.addPageLimitTitle': 'Limit reached ({max} pages)',
  'pages.addPageBtn': '+ Add Page ({count}/{max})',
  'pages.changeLayout': '🔲 Change Layout',
  'pages.addText': 'T Add Text',
  'pages.deletePage': '🗑 Delete Page',
  'pages.coverThumb': 'Cover',
  'pages.chooseLayout': 'Choose a Layout',
  'pages.alert.slotLimit': 'You have reached the maximum number of photos for this product.',
  'pages.alert.maxForProduct': 'You have reached the maximum of {max} photos for this product.\n\nRemove some photos from the pages/library to add new ones.',
  'pages.alert.limitSkipped': 'You have reached the limit of {max} photos - you can only add {remaining} more.\n\nThese photos were NOT added:\n{names}',
  'pages.alert.loadError': 'An error occurred while loading the photos.',
  'pages.alert.maxPhotosLimit': 'You have reached the maximum of {max} photos for this product.',
  'pages.alert.remainingOnly': 'You can only upload {remaining} more photos. {added} of {total} selected photos were uploaded.',
  'pages.alert.minAI': 'Please upload at least 3 photos to generate with AI.',
  'pages.alert.aiError': 'An error occurred during generation. Please try again.',
  'pages.alert.maxPages': 'You have reached the maximum number of pages ({max}).',
  'pages.deletePhotoTitle': 'Delete photo',
  'pages.moveSlot': 'Move slot',
  'pages.rotate90': 'Rotate right',
  'pages.rotateLeft90': 'Rotate left',
  'pages.rotateFree': 'Drag to rotate freely',
  'pages.fitPhoto': 'Reset crop',
  'pages.aiHintBefore': 'Upload your photos here and',
  'pages.aiHintAfter': 'will automatically create your album.',
  'pages.aiGenerateBtn': 'Generate Layout with AI',

  // Order page (OrderForm)
  'order.loadingOrder': 'Loading...',
  'order.noData': 'No order data',
  'order.backToStart': 'Back to start',
  'order.beforeUnloadWarning': 'Photo upload is in progress. Are you sure you want to leave?',
  'order.validation.firstName': 'First name is required',
  'order.validation.lastName': 'Last name is required',
  'order.validation.country': 'Country is required',
  'order.validation.city': 'City is required',
  'order.validation.address': 'Address is required',
  'order.validation.phone': 'Phone number is required',
  'order.validation.phoneInvalid': 'Phone number is not valid',
  'order.promo.applied': 'Code applied! -{pct}% discount',
  'order.promo.invalid': 'Promo code is not valid',
  'order.alert.uploadFailedSlots': '{count} photo(s) could not be uploaded and would be missing from the printed book. Please refresh the page, check the photobook pages, and place the photos again before continuing.',
  'order.error.initFailed': 'Error starting the order (Status: {status}). {text}',
  'order.error.initFailedGeneric': 'Error starting the order!',
  'order.error.noPhotosUploaded': 'No photo was uploaded successfully. Please try again with a more stable internet connection (or open this page in Safari/Chrome instead of Instagram/Facebook).',
  'order.alert.saveFailed': 'Error saving the order!',
  'order.error.checkoutFailed': 'Error creating the online payment',
  'order.error.submitFailed': 'Error submitting the order!',
  'order.error.timeout': 'The photo upload is taking a long time.\n\nThis could be because:\n- Your internet connection is slow\n- The server is busy\n\nPlease try again with a more stable internet connection.',
  'order.error.connectionDropped': 'The connection to the server dropped while submitting your order ({message}).\n\nThis usually happens because:\n- The internet connection dropped for a moment (WiFi/mobile network)\n- The phone went to the background or the screen locked during upload\n\nPlease try again with a more stable internet connection and don\'t close the page until it finishes.',
  'order.uploadTitle': 'Please stay here with us',
  'order.uploadWarning': 'It takes 3 to 5 minutes to upload all the photos in the order.',
  'order.manualSuccessTitle': 'Thank you for your order!',
  'order.manualSuccessAllOk': 'Your photos were uploaded successfully.',
  'order.manualSuccessPartial': '{done} of {total} photos were uploaded successfully.',
  'order.photoLinkReady': '📸 Your photo link is ready. You can view or copy it to save.',
  'order.someFailedManual': '⚠️ {count} photo(s) could not be uploaded: {names}. These files arrived empty from your phone - this often happens with iCloud photos that weren\'t fully downloaded, or when you open this page inside Instagram/Facebook instead of Safari/Chrome. Please try adding these photos separately, or contact us for help.',
  'order.viewPhotos': '📸 View Photos',
  'order.linkCopied': '✅ Link Copied!',
  'order.copyLink': '🔗 Copy Link',
  'order.backHome': 'Back to Home',
  'order.inAppWarningBefore': '⚠️ You\'re opening this page inside {browser}. To avoid issues uploading photos, open it in Safari or Chrome: tap ⋮ or ••• at the top right and choose',
  'order.inAppOpenBrowser': '"Open in Browser"',
  'order.inAppWarningAfter': '("Open in Browser" / "Open in Safari").',
  'order.summaryTitle': 'Order Summary',
  'order.discountApplied': '-{pct}% discount applied',
  'order.shippingLine': '€{price} + €{shipping} shipping',
  'order.pagesCount': 'Number of pages:',
  'order.photosInPages': 'Photos in pages:',
  'order.photosCountUnit': '{n} photos',
  'order.photosUploaded': 'Photos uploaded:',
  'order.photoBookDesigned': '📖 Designed Photo Book',
  'order.photoBookDesignedDesc': 'You designed {pages} pages with {photos} photos.',
  'order.pdfAutoNote': 'The PDF will be generated automatically when you submit the order.',
  'order.shippingNote': '📦 Shipping: Kosovo +€2 | Albania +€5 | Macedonia +€5',
  'order.yourPhotos': 'Your Photos:',
  'order.yourDataTitle': 'Your Details',
  'order.firstName': 'First Name *',
  'order.firstNamePlaceholder': 'Enter your first name',
  'order.lastName': 'Last Name *',
  'order.lastNamePlaceholder': 'Enter your last name',
  'order.country': 'Country *',
  'order.countrySelect': '-- Select a country --',
  'order.countryKosovo': '🇽🇰 Kosovo (+€2 shipping)',
  'order.countryAlbania': '🇦🇱 Albania (+€5 shipping)',
  'order.countryMacedonia': '🇲🇰 North Macedonia (+€5 shipping)',
  'order.city': 'City *',
  'order.cityPlaceholder': 'Enter your city',
  'order.address': 'Address *',
  'order.addressPlaceholder': 'Enter your full address',
  'order.phone': 'Phone Number *',
  'order.comments': 'Comment / Description (Optional)',
  'order.commentsPlaceholder': 'Write any comment or description for your order (optional)',
  'order.promoLabel': 'Promo Code (Optional)',
  'order.promoPlaceholder': 'Enter the promo code',
  'order.apply': 'Apply',
  'order.paymentMethod': 'Payment Method',
  'order.payCash': 'Cash on Delivery',
  'order.payCashSub': 'Pay when your order arrives',
  'order.payOnline': 'Pay Online',
  'order.payOnlineSub': 'Fast and secure payment',
  'order.payOnlineDiscountBadge': '-{pct}%',
  'order.paymentSecurityNote': 'Online payments are processed securely through Stripe.',
  'order.processingPhotoBook': '⏳ Processing Photo Book... Please wait',
  'order.processingPhotos': '⏳ Uploading photos... Please wait',
  'order.sendManual': '📤 Submit Order',
  'order.continueToPay': 'Continue to Payment',
  'order.sendWhatsApp': 'Send Order via WhatsApp',
  'order.generatingPdf': '⏳ Generating PDF with {pages} pages... Don\'t close the page!',
  'order.uploadingPhotosCount': '⏳ Uploading {n} photos... Don\'t close the page!',
  'order.noteManual': '* By clicking the button, your photos will be uploaded and you\'ll receive the link to view them',
  'order.noteCard': '* By clicking the button, you\'ll go to the secure payment page',
  'order.noteWhatsApp': '* By clicking the button, your order will be sent via WhatsApp',
  'order.successTitle': 'Order Sent Successfully!',
  'order.successOpened': 'WhatsApp should have opened automatically.',
  'order.pdfSentLabel': 'Photo Book PDF:',
  'order.pdfSentDesc': 'The PDF with {pages} pages was generated and sent with the order.',
  'order.remindSendLabel': 'Don\'t forget:',
  'order.remindSendDesc': 'Send the {n} selected photos in the WhatsApp chat!',
  'order.someFailedBackup': '⚠️ {count} photo(s) were not saved as a backup copy on our server: {names}. This often happens with iCloud photos that weren\'t fully downloaded, or when you open this page inside Instagram/Facebook. Make sure to send these photos yourself in the WhatsApp chat.',
  'order.ifNotOpened': 'If WhatsApp didn\'t open, click the button below:',
  'order.openWhatsAppManually': '📱 Open WhatsApp Manually',

  // WhatsApp order message — generated in the customer's language
  'wa.title': '🎉 *NEW ORDER* 🎉',
  'wa.product': '📦 *Product:*',
  'wa.priceBefore': '💰 *Product Price (before discount):*',
  'wa.promoCode': '🏷️ *Promo Code:*',
  'wa.priceAfterDiscount': '💸 *Price after discount:*',
  'wa.price': '💰 *Product Price:*',
  'wa.shipping': '🚚 *Shipping ({country}):*',
  'wa.totalPrice': '✅ *Total Price:*',
  'wa.bookDetails': '📖 *Book Details:*',
  'wa.bookWith': '• Book with:',
  'wa.pagesWord': 'pages',
  'wa.photosInPage': '• Number of photos in pages:',
  'wa.productDetails': '📦 *Product Details:*',
  'wa.photosCount': '• Number of photos:',
  'wa.customerData': '👤 *Customer Details:*',
  'wa.name': '• Name:',
  'wa.country': '• Country:',
  'wa.city': '• City:',
  'wa.address': '• Address:',
  'wa.phone': '• Phone:',
  'wa.comment': '• Comment:',
  'wa.bookPagesZip': '📦 *Book Pages (ZIP):*',
  'wa.downloadPages': 'Download the book pages here:',
  'wa.customerPhotos': '📸 *Customer Photos:*',
  'wa.seePhotos': 'View the photos here:',
  'wa.waitingConfirm': '⏳ Waiting for order confirmation.',
  'wa.orderDate': '*Order Date:*',

  // OrderSuccess (Stripe)
  'success.checking': 'Confirming payment...',
  'success.confirmed': 'Payment successful!',
  'success.thanks': 'Thank you for your order!',
  'success.confirmedDesc': 'Order #{id} was paid and registered. We\'ll contact you soon with shipping details.',
  'success.pendingDesc': 'Order #{id} was sent. As soon as the payment is fully confirmed, you\'ll be notified.',
  'success.sendConfirmBtn': '📱 Send Confirmation via WhatsApp',
  'success.backHome': 'Back to Home',
  'wa.success.title': '✅ *Payment successful*',
  'wa.success.paidLine': 'Order #{id} was paid online.',
  'wa.success.name': 'Name:',
  'wa.success.product': 'Product:',
  'wa.success.price': 'Price:',
  'wa.success.wantConfirm': 'I\'d like confirmation of the order.',

  // OrderCancel (Stripe)
  'cancel.orderNotFound': 'Order not found',
  'cancel.genericError': 'Error creating the payment',
  'cancel.retryError': 'Error retrying the payment. Please try again.',
  'cancel.title': 'Payment cancelled',
  'cancel.desc': 'Order #{id} has been saved, but the payment was not completed. You can try again, or contact us on WhatsApp to arrange cash payment.',
  'cancel.retrying': '⏳ Opening payment...',
  'cancel.retryBtn': '💳 Try Again',
  'cancel.contactBtn': '📱 Contact on WhatsApp',
  'wa.cancel.message': 'Hi, I have an order (#{id}) but the online payment didn\'t go through. Can we arrange it with cash?',

  // OrderImages
  'images.loading': 'Loading photos...',
  'images.notFoundTitle': '❌ Order not found!',
  'images.notFoundDesc': 'The link may be old or invalid.',
  'images.pageTitle': '📸 Order Photos',
  'images.back': '← Back',
  'images.cardTitle': 'Order Photos',
  'images.orderId': 'Order ID:',
  'images.photoCount': 'Number of photos:',
  'images.date': 'Date:',
  'images.downloadAll': '⬇️ Download all photos ({n})',
  'images.downloadHint': 'Or click any photo to download it individually',
  'images.download': '⬇️ Download',
  'images.photoWord': 'Photo {n}',
  'images.noImages': 'No photos uploaded for this order.',
  'images.homeBtn': '🏠 Back to Home',

  // Policy pages
  'policy.backLink': '← Back to homepage',

  'policy.privacy.title': 'Privacy Policy',
  'policy.privacy.subtitle': 'Fletaime - Protecting your data',
  'policy.privacy.intro': 'Fletaime respects and protects the privacy of every user of our platform. This policy explains how we collect, use, and protect the data and materials that users upload to our platform.',
  'policy.privacy.s1Title': 'Data Collection',
  'policy.privacy.s1Text': 'While using the Fletaime platform, users may upload photos and provide basic details such as first name, last name, and the information needed to fulfil an order. This data is used only for processing and fulfilling the customer\'s order.',
  'policy.privacy.s2Title': 'Photo Security',
  'policy.privacy.s2Text': 'We guarantee that all photos uploaded by users are handled with a high level of security and privacy. Photos are used only to produce the album or product ordered and are not used for any other purpose.',
  'policy.privacy.s2Guarantee': 'Fletaime guarantees that:',
  'policy.privacy.s2Li1': 'Photos are not shared with third parties.',
  'policy.privacy.s2Li2': 'Photos are not used for marketing or promotion without the customer\'s permission.',
  'policy.privacy.s2Li3': 'They are stored on secure systems during order processing.',
  'policy.privacy.s3Title': 'Deletion of Photos',
  'policy.privacy.s3Text': 'After the design, production, and delivery process for the customer\'s order is complete, the uploaded photos are deleted from our systems within a reasonable technical period. This is done to fully guarantee the privacy and security of the customer\'s materials.',
  'policy.privacy.s4Title': 'Data Protection',
  'policy.privacy.s4Text': 'Fletaime operates in accordance with the applicable legislation in the Republic of Kosovo on the protection of personal data and takes technical and organisational measures to protect user information from unauthorised access, loss, or misuse.',

  'policy.return.title': 'Return Policy',
  'policy.return.subtitle': 'Fletaime - Guarantee and quality',
  'policy.return.intro': 'Fletaime is committed to offering quality products made according to customer requirements. Every order goes through several inspection stages before it is shipped to the customer.',
  'policy.return.s1Title': 'Quality Control',
  'policy.return.s1Text': 'Before shipping, every ordered album or product is checked in detail by our team to make sure that:',
  'policy.return.s1Li1': 'The design was made according to the customer\'s requirements',
  'policy.return.s1Li2': 'The materials and printing are in perfect condition',
  'policy.return.s1Li3': 'The product is finished according to our quality standards',
  'policy.return.s1Note': 'Only after this check is the order sent for shipping.',
  'policy.return.s2Title': 'Damage During Shipping',
  'policy.return.s2Text': 'In some cases, the product may be damaged during shipping by the delivery company. If the customer receives the order and notices it arrived damaged, Fletaime offers a product replacement at no extra cost.',
  'policy.return.s3Title': 'Design or Production Errors',
  'policy.return.s3Text': 'The customer is entitled to a replacement order in cases where:',
  'policy.return.s3Li1': 'The design was not made according to the customer\'s requirements',
  'policy.return.s3Li2': 'The design team forgot to include elements requested by the customer',
  'policy.return.s3Li3': 'There are visible errors from the production process',
  'policy.return.s3Li4': 'The final product does not match the confirmed order',
  'policy.return.s3Note': 'In these cases, Fletaime takes responsibility for fixing or replacing the product.',
  'policy.return.s4Title': 'Cases Where Returns Are Not Accepted',
  'policy.return.s4Text': 'Because products are personalised for each customer, returns are not accepted in cases where:',
  'policy.return.s4Li1': 'The customer changes their mind after the order has been produced',
  'policy.return.s4Li2': 'The order was made exactly according to the request confirmed by the customer',
  'policy.return.s4Li3': 'There is no physical damage or error from the design or production team',

  // Mobile upload (QR pairing) page
  'mobileUpload.title': 'Add photos from your phone',
  'mobileUpload.subtitle': 'Pick your photos and they\'ll appear automatically on your computer.',
  'mobileUpload.addPhotos': 'Add Photos',
  'mobileUpload.addMore': 'Add More',
  'mobileUpload.uploading': 'Uploading {done}/{total}...',
  'mobileUpload.done': '{count} photo(s) uploaded successfully!',
  'mobileUpload.doneHint': 'Go back to your computer - the photos are already added.',
  'mobileUpload.error': 'Something went wrong. Please try again.',
  // Faqja Rreth nesh
  'about.hero.title': 'Every memory deserves to be kept forever.',
  'about.hero.lead': 'Fletaime was born from a simple idea with a special meaning: to give our memories a place where they can be kept, touched and lived again, no matter how much time passes.',
  'about.story.eyebrow': 'Our story',
  'about.story.title': 'An idea born in 2021, made real in 2025.',
  'about.story.p1': 'The Fletaime story began in 2021, with the desire to create something special that would help people preserve the most important moments of their lives.',
  'about.story.p2': 'But for us, simply making a photo album was not enough. We wanted to develop a product that would meet our customers\' expectations, paying attention to every detail, from the first idea to the final experience.',
  'about.story.p3': 'For that reason, in the years that followed we dedicated ourselves to developing the idea, testing and refining the concept, with the aim of creating a product that would represent us worthily.',
  'about.story.p4': 'In 2025, the idea took concrete shape with the launch of the first version of our album. This was only the beginning of Fletaime\'s journey and of our mission to turn photos into lasting memories.',
  'about.story.p5': 'Today, we keep working to make every album more than a collection of photos: a personal story that deserves to be kept forever.',
  'about.tl.2021.title': 'The idea',
  'about.tl.2021.text': 'The wish to preserve life\'s most important moments is born.',
  'about.tl.dev.title': 'Development',
  'about.tl.dev.text': 'Years of dedication: testing and refining the concept.',
  'about.tl.2025.title': 'First album',
  'about.tl.2025.text': 'The idea takes shape with the launch of the first version.',
  'about.tl.today.title': 'Today',
  'about.tl.today.text': 'Every album, a personal story worth keeping.',
  'about.mission.eyebrow': 'Our mission',
  'about.mission.title': 'Life\'s most precious memories, in a special and lasting form.',
  'about.mission.p1': 'Our mission is to help people preserve the most precious memories of their lives in a special, personal and long-lasting form.',
  'about.mission.p2': 'We want every customer who chooses Fletaime to enjoy an easy and pleasant process, from creating the album to the moment they hold it in their hands. For us, success is measured not only by a finished product, but by customer satisfaction and the emotion they feel when they return to their memories.',
  'about.mission.p3': 'Every album we create represents a unique story. That is why we aim to always keep quality, attention to detail and customer satisfaction at the heart of our work.',
  'about.mission.quote': 'We don\'t just preserve photos. We help preserve the stories that matter.',
  'about.val.quality': 'Quality',
  'about.val.detail': 'Attention to detail',
  'about.val.satisfaction': 'Customer satisfaction',
  'about.vision.eyebrow': 'Our vision',
  'about.vision.title': 'Memories know no borders.',
  'about.vision.p1': 'Our vision is for Fletaime to become the choice of people everywhere in the world when they want to turn their memories into special albums.',
  'about.vision.p2': 'We believe memories know no borders and that every person, wherever they live, deserves the chance to keep the most important moments of their life in a form they can hold close forever.',
  'about.vision.p3': 'That is why our goal is to expand Fletaime\'s services to as many countries as possible, offering customers from different places the chance to create their albums, with the same dedication to quality and customer experience.',
  'about.vision.ambition': 'Our ambition is clear: from an idea born in 2021, towards a brand that brings together people\'s memories all over the world.',
  'about.closing.title': 'Fletaime – Your memories, your story.',
  'about.closing.cta': 'Create your album',

  // Faqja e kontaktit
  'contact.eyebrow': 'Contact',
  'contact.title': 'Write to us, we are here for you.',
  'contact.lead': 'Have a question, a complaint or an idea for us? Get in touch and we will reply as soon as possible.',
  'contact.whatsapp': 'WhatsApp',
  'contact.instagram': 'Instagram',
  'contact.email': 'Email',
  'contact.whatsappHint': 'Message us directly',
  'contact.instagramHint': 'Follow us and send a message',
  'contact.emailHint': 'We reply as soon as possible',
  'contact.form.title': 'Send a message',
  'contact.form.type': 'What would you like to send?',
  'contact.form.type.request': 'Request',
  'contact.form.type.complaint': 'Complaint',
  'contact.form.type.suggestion': 'Suggestion',
  'contact.form.name': 'Full name',
  'contact.form.email': 'Email address',
  'contact.form.phone': 'Phone number (optional)',
  'contact.form.message': 'Your message',
  'contact.form.send': 'Send message',
  'contact.form.sending': 'Sending...',
  'contact.form.success': 'Thank you! Your message was sent successfully. We will get back to you soon.',
  'contact.form.error': 'Something went wrong. Please try again or message us on WhatsApp.',
  'contact.form.tooMany': 'You have sent too many messages. Please try again shortly.',
};

export default en;
